export type Environment = 'dev' | 'stg' | 'prod';

const DEV_ENV_HOSTNAMES = [
	'localhost',
	'127.0.0.1',
	'0.0.0.0',
	'statlas.atl-paas.net',
	'atlaskit.atlassian.com',
];

export function getEnvironment(): Environment {
	if (DEV_ENV_HOSTNAMES.includes(window.location.hostname)) {
		return 'dev';
	} else if (window.location.host.includes('-dev.com')) {
		return 'stg';
	} else {
		return 'prod';
	}
}
